var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { computed } from "mobx";
export class BlockchainOperationsDialogModel {
    constructor(container) {
        this.blockchainOperationManager = container.blockchainOperationManager;
    }
    get dialogOpen() {
        return this.blockchainOperationManager.state === "SUBMITTING" || this.blockchainOperationManager.state === "VERIFYING";
    }
    get showWaitingText() {
        return this.blockchainOperationManager.state === "SUBMITTING";
    }
    get showVerifyingText() {
        return this.blockchainOperationManager.state === "VERIFYING";
    }
}
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], BlockchainOperationsDialogModel.prototype, "dialogOpen", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], BlockchainOperationsDialogModel.prototype, "showWaitingText", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], BlockchainOperationsDialogModel.prototype, "showVerifyingText", null);
